import { render, staticRenderFns } from "./filter-table.component.vue?vue&type=template&id=6a2d0e44"
import script from "./filter-table.component.vue?vue&type=script&lang=js"
export * from "./filter-table.component.vue?vue&type=script&lang=js"
import style0 from "./filter-table.component.vue?vue&type=style&index=0&id=6a2d0e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports